import { render } from "./PreLoaderArticles.vue?vue&type=template&id=39788f4a&scoped=true"
const script = {}

import "./PreLoaderArticles.vue?vue&type=style&index=0&id=39788f4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39788f4a"]])

export default __exports__